export const handleKeyDownNumber = (event: React.KeyboardEvent) => {
  const { key, target } = event;

  if (
    !/\d/.test(key) &&
    key !== '.' &&
    key !== 'Backspace' &&
    key !== 'Tab' &&
    key !== 'ArrowLeft' &&
    key !== 'ArrowRight'
  ) {
    event.preventDefault();
  }
  if (key === '.' && (target as HTMLInputElement).value.includes('.')) {
    event.preventDefault();
  }
};
